import React from "react";

/**
 * RShield - Capture Detection warning badge.
 *
 * Rendered as a ribbon item so it inherits the ribbon's own vertical centring
 * instead of being positioned by hand. The RPD has two ribbons with different
 * markup conventions, hence the variant:
 *
 *   desktop  ul.no-bullets (display:flex) > li.nav-item > span.r-nav-link
 *            Right aligned with ms-auto, which takes up the free space to its
 *            left so the icon sits against the right edge of the ribbon.
 *
 *   mobile   ul.navbar-nav > li.nav-item.res-w100.res-border > span.nav-link
 *            A stacked dropdown, so it is a normal item with the text label
 *            the other entries carry - right alignment does not apply.
 *
 * Shown only when the sender enabled Notify Sender, so the reader is warned
 * before an attempt rather than only finding out afterwards. It is a span
 * rather than a link or button because there is nothing to click.
 */
export function CaptureWarning({ enabled, message, label, variant = "desktop" }) {
  if (!enabled) return null;

  const text =
    message ||
    "Warning: Screen capture is not permitted by doc owner. Doc owner will be notified if you attempt to use screen capture tools.";

  if (variant === "mobile") {
    return (
      <li className="nav-item res-w100 res-border dp-capture-warning-item">
        <span
          className="rpdFont text-white nav-link d-flex align-items-center active dp-capture-warning"
          role="note"
          tabIndex={0}
          aria-label={text}
        >
          <span className="material-icons dp-capture-warning-icon"> warning </span>
          <span className="rpdFont text-white ms-3">
            {label || "Screen capture not permitted"}
          </span>
          <span className="dp-capture-warning-tip" role="tooltip">
            {text}
          </span>
        </span>
      </li>
    );
  }

  return (
    <li className="nav-item ms-auto dp-capture-warning-item">
      <span
        className="r-nav-link dp-capture-warning"
        role="note"
        tabIndex={0}
        aria-label={text}
      >
        <span className="material-icons dp-capture-warning-icon"> warning </span>
        <span className="dp-capture-warning-tip" role="tooltip">
          {text}
        </span>
      </span>
    </li>
  );
}

export default CaptureWarning;
